import React, { useRef, useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ICON_SAVE, ICON_CANCEL } from '../../extras/icons';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveDependenciesAction, updateDependenciesAction } from '../../../actions/dependenciesActions';
import { listDependencyTypesAction } from '../../../actions/dependencyTypesActions';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
import ButtonSpinner from '../../layout/ButtonSpinner';
//Función principal
const DependencyForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refDescription = useRef();
    //Datos iniciales
    const initialData = {
        descripcion: '',
        tipo: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const dependenciesLoading = useSelector( state => state.dependencies.loadingSave );
    const errorSave = useSelector( state => state.dependencies.errorSave );
    const isEdit = useSelector( state => state.dependencies.isEdit );
    const dependencySelected = useSelector( state => state.dependencies.dependencySelected );
    const dependencyTypes = useSelector( state => state.dependencyTypes.dependencyTypes );
    //Inicializo el state local
    const [ dependency, setDependency ] = useState(initialData);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && dependencySelected){
            setDependency({
                ...dependencySelected,
                tipo: dependencySelected.tipo ? dependencySelected.tipo.id : ''
            });
        }else{
            setDependency(initialData);
        }
    }, [isEdit, dependencySelected, show])
    //Manejo el guardado
    const handleSave = values => {
        //Armo los datos
        let data = {
            ...values,
            tipo: {
                id: values.tipo
            },
            activo: 1
        }
        //Verifico si es edición o alta
        if(dependency.id){
            //Agrego el ID
            data = {
                id: dependency.id,
                ...data
            }
            //Es edición
            dispatch( updateDependenciesAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveDependenciesAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Tengo que cargar los tipos
        dispatch( listDependencyTypesAction({
            search: 'activo:1',
            sort: 'descripcion:asc'
        }) );
        //Pongo el foco en el primer campo
        refDescription.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setDependency(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        descripcion: yup.string().required(),
        tipo: yup.number().required()
    });
    //Renderizo
    return (
        <Modal 
            show={show} 
            onHide={handleCloseForm} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Dependencia&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...dependency }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-12">
                                    <label htmlFor="descripcion">Descripción</label>
                                    <Form.Control
                                        id="descripcion"
                                        className="form-control" 
                                        //required
                                        autoFocus 
                                        name="descripcion" 
                                        type="text" 
                                        value={ values.descripcion }
                                        onChange={handleChange}
                                        ref={refDescription}
                                        isInvalid={!!errors.descripcion}
                                        disabled={ dependenciesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.descripcion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="tipo">Tipo</label>
                                    <Form.Control
                                        as="select"
                                        id="tipo"
                                        className="form-control"  
                                        name="tipo" 
                                        type="text" 
                                        value={ values.tipo }
                                        onChange={handleChange}
                                        isInvalid={!!errors.tipo}
                                        disabled={ dependenciesLoading }
                                    >
                                        <option value="">Seleccione el Tipo</option>
                                        {
                                            dependencyTypes ? (
                                                dependencyTypes.map(type => (
                                                    <option value={type.id} key={`dt${type.id}`}>
                                                        { type.descripcion }
                                                    </option>
                                                ))
                                            ) : null 
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.tipo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                dependenciesLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ dependenciesLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ dependenciesLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default DependencyForm;